import { render, staticRenderFns } from "./constructionPersonnel.vue?vue&type=template&id=c894b8a2&scoped=true&"
import script from "./constructionPersonnel.vue?vue&type=script&lang=js&"
export * from "./constructionPersonnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c894b8a2",
  null
  
)

export default component.exports